import { Link, Typography } from '@material-ui/core';
import { ImageContainer, MediaItem } from 'pages/PastSelfTapes/PastSelfTape/RoleDetails/RoleDetails.styles';
import React, { useMemo, useState } from 'react';
import ImageGallery from 'shared/components/ImageGallery/ImageGallery';
import MediaContainer from 'shared/components/MediaContainer/MediaContainer';
import { COLORS } from 'shared/constants/COLORS';
import { AuditionStatus } from 'shared/enums/AuditionStatus';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IAuditionScheduleAttributes } from 'shared/interfaces/IAuditionSchedule';
import { SectionCont, SectionTitle } from './Response.styles';
import LinkItem from 'shared/components/LinkItem/LinkItem';

interface Props {
  data: IAuditionScheduleAttributes | undefined;
  note: string;
  location: string;
}

const StudioLayout: React.FC<Props> = ({ data, note, location }) => {
  const getSides = useMemo(
    () =>
      data?.audition
        ? data?.audition.casting_role.medium_attachments.filter(
            (f) => f.medium.file_type.toLocaleLowerCase() !== 'image',
          )
        : [],
    [data],
  );

  const getPhotos = useMemo(
    () =>
      data?.audition
        ? data?.audition.casting_role.medium_attachments.filter(
            (f) => f.medium.file_type.toLocaleLowerCase() === 'image',
          )
        : [],
    [data],
  );

  const links = useMemo(() => {
    return data?.audition?.casting_role?.reference_urls;
  }, [data]);

  const { width } = useWindowDimensions();
  const [imageIndex, setimageIndex] = useState<number>(0);
  const [showImageModal, setshowImageModal] = useState<boolean>(false);

  const renderPhotos = () => {
    if (data) {
      const img = (getPhotos as any).map((image: any, idx: number) => {
        return {
          id: image.id,
          src: image.modified_attachment || image.attachment,
          height: image.medium.file_height,
          width: image.medium.file_width,
          idx: idx + 1,
        };
      });
      return img;
    } else {
      return;
    }
  };

  const renderedImages = renderPhotos();

  const handleClick = (idx: number) => {
    setimageIndex(idx);
    setshowImageModal(true);
  };

  const status = data?.status;

  return (
    <div style={{ gap: 20, display: 'flex', flexDirection: 'column' }}>
      {location ? (
        <SectionCont>
          <SectionTitle>Location:</SectionTitle>
          <Typography style={{ fontWeight: 700 }}>{location}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}

      {data?.schedule?.casting_session?.zoom_meeting_url &&
        data?.schedule?.casting_session?.audition_type.toLowerCase() !== 'studio' && (
          <SectionCont>
            <SectionTitle>Session:</SectionTitle>
            <Typography style={{ fontSize: 15 }}>
              <span style={{ fontWeight: 'bold' }}>Name:</span> {data?.schedule?.casting_session?.name}
            </Typography>
            <Typography style={{ fontSize: 15 }}>
              <span style={{ fontWeight: 'bold' }}>Audition Type:</span>{' '}
              {data?.schedule?.casting_session?.audition_type}
            </Typography>
            <Typography style={{ fontSize: 15, fontWeight: 'bold' }}>Meeting URL:</Typography>
            <Link style={{ fontSize: 15 }} href={data?.schedule?.casting_session?.zoom_meeting_url} target="_blank">
              {data?.schedule?.casting_session?.zoom_meeting_url}
            </Link>
            <Typography style={{ fontSize: 15 }}>
              <span style={{ fontWeight: 'bold' }}>Meeting ID:</span> {data?.schedule?.casting_session?.meeting_id}
            </Typography>
            <Typography style={{ fontSize: 15 }}>
              <span style={{ fontWeight: 'bold' }}>Meeting Password:</span>{' '}
              {data?.schedule?.casting_session?.meeting_password}
            </Typography>
          </SectionCont>
        )}

      {(getPhotos as any).length ? (
        <SectionCont>
          <SectionTitle>Reference Images:</SectionTitle>
          <ImageContainer style={{ marginTop: 10 }}>
            {(getPhotos as any).map((i: any, idx: number) => (
              <MediaItem src={i.attachment} style={{ objectFit: 'cover' }} onClick={() => handleClick(idx + 1)} />
            ))}
          </ImageContainer>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}
      {getSides.length ? (
        <>
          <div
            style={{
              padding: 10,
              borderRadius: 8,
              border: `${COLORS.PRIMARY} dashed 1px`,
              display: 'flex',
              alignItems: 'center',
              background: '#3e8bff1a',
              gap: 10,
            }}
          >
            <Typography style={{ fontWeight: 500 }}>Sides: </Typography>
            <div style={{ flexWrap: 'wrap', display: 'flex', gap: 15 }}>
              {getSides.map((i) => (
                <MediaContainer key={i.id} media={i} style={{ padding: 15 }} />
              ))}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {links && links.length ? (
        <SectionCont>
          <div style={{ display: 'flex', gap: 10 }}>
            {links.map((l) => (
              <LinkItem url={l} />
            ))}
          </div>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}
      {note ? (
        <SectionCont>
          <SectionTitle>Instruction for Talent:</SectionTitle>
          <Typography style={{ fontWeight: 700, whiteSpace: 'pre-line' }}>{note}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}

      {status === AuditionStatus.CANCELLED && data?.schedule?.casting_session.cancelled_note ? (
        <SectionCont>
          <SectionTitle>Additional Instruction:</SectionTitle>
          <Typography style={{ fontWeight: 700 }}>{data?.schedule?.casting_session.cancelled_note}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}

      {(status === AuditionStatus.CD_RESCHEDULE ||
        status === AuditionStatus.DECLINED ||
        status === AuditionStatus.FORWARDED ||
        status === AuditionStatus.RESCHEDULE ||
        status === AuditionStatus.CONFIRMED) &&
      data?.schedule?.casting_session.new_talent_note ? (
        <SectionCont>
          <SectionTitle>Additional Instruction:</SectionTitle>
          <Typography style={{ fontWeight: 700 }}>{data?.schedule?.casting_session.new_talent_note}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}

      {status === AuditionStatus.FORWARDED &&
      data?.schedule?.casting_session.pending_note &&
      !data?.schedule?.casting_session.new_talent_note ? (
        <SectionCont>
          <SectionTitle>Additional Instruction:</SectionTitle>
          <Typography style={{ fontWeight: 700 }}>{data?.schedule?.casting_session.pending_note}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}

      {data?.schedule?.casting_session.wardrobe_note ? (
        <SectionCont>
          <SectionTitle>Wardrobe Note:</SectionTitle>
          <Typography style={{ fontWeight: 700 }}>{data?.schedule?.casting_session.wardrobe_note}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )}

      {/* {note ? (
        <SectionCont>
          <SectionTitle>Additional Instruction:</SectionTitle>
          <Typography style={{ fontWeight: 700 }}>{note}</Typography>
        </SectionCont>
      ) : (
        <React.Fragment />
      )} */}
      <ImageGallery
        fullScreen={width < 960}
        current={imageIndex - 1}
        images={renderedImages}
        thumbnails={renderedImages}
        open={showImageModal}
        onClose={() => setshowImageModal(false)}
      />
    </div>
  );
};

export default StudioLayout;
